<template>
  <v-card>
    <v-card-title>
      Szczegóły kodu
    </v-card-title>
    <v-card-text>
      <AddCode
          :code="this.code"
      ></AddCode>
    </v-card-text>
  </v-card>
</template>
<script>
import AddCode from "@/components/codes/AddCode";

export default {
  components: {
    AddCode,
  },
  props: {
    code: {
      type: [String],
      required: true,
    }
  },
}
</script>